import React from 'react';
import { Label, LabelText, FaSvg, Box } from '@zen-common/components-base';
import styled from 'styled-components';

import { numberUtils } from '@zen/common-utils';
import { faWallet } from '@fortawesome/pro-solid-svg-icons';
import { NamingAssetStore, NamingUtils } from '@zen/common-app-parts';

/**
 * Display the available amount
 *
 * @export
 * @param {Object} props
 * @param {string} props.base - the base asset
 * @param {string} props.quote - the quote asset
 * @param {Object} props.available - asset and amount
 * @param {boolean} props isBuy - is a buy order or a sell order
 */
export default function Available({ base, quote, available, isBuy = true }) {
  const { state: naming } = NamingAssetStore.useStore();
  const priceAsset = isBuy ? quote : base;
  return (
    <>
      <AvailableContainer>
        <Label>
          <LabelText>
            {available && (
              <>
                <IconWrapper icon={faWallet} /> {numberUtils.toDisplay(available.amount, 2)}{' '}
                <Wrapper as="span">{NamingUtils.displayName(available.asset, naming)}</Wrapper>
              </>
            )}
            {!available && priceAsset && (
              <>
                <IconWrapper icon={faWallet} /> 0
                <Wrapper as="span">{NamingUtils.displayName(priceAsset, naming)} </Wrapper>
              </>
            )}
          </LabelText>
        </Label>
      </AvailableContainer>
    </>
  );
}

const AvailableContainer = styled(Box)`
  display: flex;
  margin-bottom: 10px;
  margin-top: 5px;
`;
const IconWrapper = styled(FaSvg)`
  align-items: center;
  font-size: 14px;
  margin-top: -4px;
  margin-right: 8px;
`;
const Wrapper = styled(Box)`
  text-align: justify;
  margin-left: 10px;
`;
